import React, { useEffect, useState } from "react";
import axios from "axios";
import { apiUrl, fileUrl } from "../apiConfig";
import "./NewsEvents.css";

const API_BASE = apiUrl();

function NewsEvents() {
    const [uploads, setUploads] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchUploads();
    }, []);

    const fetchUploads = async () => {
        try {
            const res = await axios.get(
                `${API_BASE}/news_file_get.php`
            );

            setUploads(Array.isArray(res.data) ? res.data : []);

        } catch (error) {
            console.error("Error fetching notices:", error);
            setUploads([]);
        } finally {
            setLoading(false);
        }
    };

    const openNotice = (filePath) => {

        if (!filePath) return;

        const url = fileUrl(filePath);

        window.open(
            url,
            "_blank",
            "noopener,noreferrer"
        );
    };

    return (
        <section className="news-events-section" style={{background:'transparent'}} >

            <div className="news-events-container-">

                {/* ================================
                    HEADING
                ================================= */}

                <div className="news-heading">

                    <div className="news-heading-icon">
                        <i className="fa fa-bullhorn"></i>
                    </div>

                    <div>
                        <span className="news-small-title">
                            Sree Padmanabhaswamy Temple
                        </span>

                        <h2>
                            Latest Updates
                        </h2>
                    </div>

                </div>


                {/* ================================
                    HEADING LINE
                ================================= */}

                <div className="news-heading-line">
                    <span></span>
                </div>


                {/* ================================
                    LOADING
                ================================= */}

                {loading && (

                    <div className="news-loading">

                        <div className="news-loader"></div>

                        <span>
                            Loading latest updates...
                        </span>

                    </div>

                )}


                {/* ================================
                    EMPTY
                ================================= */}

                {!loading && uploads.length === 0 && (

                    <div className="news-empty">

                        <i className="fa fa-info-circle"></i>

                        <span>
                            No latest updates available.
                        </span>

                    </div>

                )}


                {/* ================================
                    NOTICE LIST
                ================================= */}

                {!loading && uploads.length > 0 && (

                    <div className="news-list">

                        {uploads.map((item, index) => (

                            <article
                                key={item.id || index}
                                className={`news-item ${
                                    item.file_path
                                        ? "news-clickable"
                                        : ""
                                }`}
                                onClick={() =>
                                    openNotice(item.file_path)
                                }
                            >

                                {/* Number */}

                                <div className="news-number">

                                    <span>
                                        {String(index + 1).padStart(2, "0")}
                                    </span>

                                </div>


                                {/* Icon */}

                                <div className="news-icon">

                                    <i className="fa fa-file-text-o"></i>

                                </div>


                                {/* Content */}

                                <div className="news-content">

                                    <h3>
                                        {item.name || "Latest Update"}
                                    </h3>

                                    <span className="news-meta">
                                        <i className="fa fa-calendar-o"></i>

                                        &nbsp; Temple Notification
                                    </span>

                                </div>


                                {/* Arrow */}

                                <div className="news-arrow">

                                    <i className="fa fa-angle-right"></i>

                                </div>

                            </article>

                        ))}

                    </div>

                )}

            </div>

        </section>
    );
}

export default NewsEvents;
